/** Centrální mapping ikon prototypu na lucide-react.
 *  Brief & Design Manual §3 stroke 1.6 default. */

import {
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Bell,
  Calendar,
  CalendarArrowDown,
  Camera,
  Check,
  ChevronDown,
  ChevronRight,
  FileText,
  Filter,
  Image as ImageIcon,
  Layers,
  LayoutGrid,
  Loader2,
  LogOut,
  Map as MapIcon,
  MapPin,
  Phone,
  Plus,
  Receipt,
  Scale,
  Search,
  ShoppingBag,
  Sparkles,
  Truck,
  User,
  X,
  type LucideProps,
} from "lucide-react";
import type { ComponentType } from "react";

const wrap = (Icon: ComponentType<LucideProps>) =>
  function WrappedIcon(props: LucideProps) {
    return <Icon strokeWidth={1.6} {...props} />;
  };

export const Ic = {
  Dashboard: wrap(LayoutGrid),
  Calendar: wrap(Calendar),
  CalendarNext: wrap(CalendarArrowDown),
  Stack: wrap(Layers),
  Receipt: wrap(Receipt),
  Scale: wrap(Scale),
  Map: wrap(MapIcon),
  User: wrap(User),
  Bell: wrap(Bell),
  ArrowRight: wrap(ArrowRight),
  ArrowLeft: wrap(ArrowLeft),
  ArrowUpRight: wrap(ArrowUpRight),
  Chevron: wrap(ChevronRight),
  ChevronDown: wrap(ChevronDown),
  Search: wrap(Search),
  Filter: wrap(Filter),
  Pin: wrap(MapPin),
  Phone: wrap(Phone),
  File: wrap(FileText),
  Camera: wrap(Camera),
  Alert: wrap(AlertTriangle),
  Check: wrap(Check),
  Close: wrap(X),
  Logout: wrap(LogOut),
  Truck: wrap(Truck),
  Spark: wrap(Sparkles),
  Plus: wrap(Plus),
  Image: wrap(ImageIcon),
  Loader: wrap(Loader2),
  Shop: wrap(ShoppingBag),
} as const;

export type IconKey = keyof typeof Ic;
